// There is no bluetooth radio to toggle from a web page.
// Report it as enabled so the print flow reaches the browser printer.
export const BluetoothStatus = {
  state: () => Promise.resolve(true),
  enable: () => Promise.resolve(true),
  disable: () => Promise.resolve(false),
  addListener: () => {},
  removeListener: () => {},
};

export default BluetoothStatus;
